import { render, staticRenderFns } from "./ShiftPointInfoModal.vue?vue&type=template&id=6f6388f2&scoped=true&"
import script from "./ShiftPointInfoModal.vue?vue&type=script&lang=js&"
export * from "./ShiftPointInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ShiftPointInfoModal.vue?vue&type=style&index=0&id=6f6388f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6388f2",
  null
  
)

export default component.exports